import { render, staticRenderFns } from "./saveButton.vue?vue&type=template&id=2cc962ae&"
import script from "./saveButton.vue?vue&type=script&lang=ts&"
export * from "./saveButton.vue?vue&type=script&lang=ts&"
import style0 from "./saveButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports